import { Mesh, PlaneGeometry, RawShaderMaterial, Vector2 } from "three";
import { circle_fragments, vertex_2 } from "../shaders/shader";
import { FboBase } from "./FboBase";


export class ExternalForce extends FboBase {
    constructor(simProps) {
        super({
            common: simProps.common,
            output: simProps.dst
        }),
        this.simProps = simProps;
        this.init(simProps)
    }
    init(props) {
        super.init();
        const planceGeo = new PlaneGeometry(1,1)
          , material = new RawShaderMaterial({
            vertexShader: vertex_2,
            fragmentShader: circle_fragments,
            blending: 2,
            uniforms: {
                px: {
                    value: props.cellScale
                },
                force: {
                    value: new Vector2(0,0)
                },
                center: {
                    value: new Vector2(0,0)
                },
                scale: {
                    value: new Vector2(props.cursor_size,props.cursor_size)
                }
            }
        });
        this.mouse = new Mesh(planceGeo,material),
        this.scene.add(this.mouse)
    }
    update(e) {
        let t = this.simProps.mouse.diff.x / 2 * e.mouse_force
          , i = this.simProps.mouse.diff.y / 2 * e.mouse_force;
        const s = e.cursor_size * e.cellScale.x
          , r = e.cursor_size * e.cellScale.y;
        let c = Math.min(Math.max(this.simProps.mouse.coords.x, -1 + s + e.cellScale.x * 2), 1 - s - e.cellScale.x * 2)
          , p = Math.min(Math.max(this.simProps.mouse.coords.y, -1 + r + e.cellScale.y * 2), 1 - r - e.cellScale.y * 2);
        const uniforms = this.mouse.material.uniforms;
        uniforms.force.value.set(t, i);
        uniforms.center.value.set(c, p);
        uniforms.scale.value.set(e.cursor_size, e.cursor_size);
        super.update();
    }
}